import React from "react";
import "./WeatherAnimatedClouds.css";

export default function WeatherAnimatedClouds() {
    return(
        <div className="WeatherAnimatedClouds">
        <div className="cloud one"></div>
        <div className="cloud two"></div>
        <div className="cloud three"></div>
        <div className="cloud four"></div>
        <div className="cloud five"></div>
        </div>
    );
}